module.exports = __webpack_public_path__ + "static/Mantra Health-18ac079f9cacbc94d18cf515676a8ca1.jpg";